// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"EditReferenceText_inputContainer__3i3p_"};